import classNames from "classnames";
import React from "react";
import { styled } from "styled-components";

type Props = {
  children: React.ReactNode;
  $variant: string;
  className?: string;
  $hasPadding?: boolean;
  as?: keyof JSX.IntrinsicElements | React.ComponentType;
};

export const BodyText = ({
  $hasPadding = true,
  as = "p",
  className,
  ...props
}: Props) => {
  return (
    <StyledBodyText
      className={classNames($hasPadding ? "pb-4" : "pb-0", className)}
      as={as}
      {...props}
    />
  );
};

export const StyledBodyText = styled.p<Props>`
  ${({ $variant, theme }) => {
    if ($variant === "b1impactbold") {
      return theme.typography.bodyText["b1impactbold"];
    }
    if ($variant === "b1impact") {
      return theme.typography.bodyText["b1impact"];
    }
    if ($variant === "b2bold") {
      return theme.typography.bodyText["b2bold"];
    }
    if ($variant === "b2reg") {
      return theme.typography.bodyText["b2reg"];
    }
    if ($variant === "b3impact") {
      return theme.typography.bodyText["b3impact"];
    }
    if ($variant === "b3bold") {
      return theme.typography.bodyText["b3bold"];
    }
    if ($variant === "b3reg") {
      return theme.typography.bodyText["b3reg"];
    }
    if ($variant === "b4impactbold") {
      return theme.typography.bodyText["b4impactbold"];
    }
    if ($variant === "b4impactreg") {
      return theme.typography.bodyText["b4impactreg"];
    }
    if ($variant === "b4bold") {
      return theme.typography.bodyText["b4bold"];
    }
    if ($variant === "b4reg") {
      return theme.typography.bodyText["b4reg"];
    }
    if ($variant === "b5bold") {
      return theme.typography.bodyText["b5bold"];
    }
    if ($variant === "b5reg") {
      return theme.typography.bodyText["b5reg"];
    }
    if ($variant === "b6impactbold") {
      return theme.typography.bodyText["b6impactbold"];
    }
    if ($variant === "b6impact") {
      return theme.typography.bodyText["b6impact"];
    }
    if ($variant === "b6bold") {
      return theme.typography.bodyText["b6bold"];
    }
    if ($variant === "b6reg") {
      return theme.typography.bodyText["b6reg"];
    }
    if ($variant === "b7bold") {
      return theme.typography.bodyText["b7bold"];
    }
    if ($variant === "b7reg") {
      return theme.typography.bodyText["b7reg"];
    }

    console.warn(
      `BodyText Component style warning: No style found for variant: ${$variant}`,
    );
  }}}
`;
